<template>
  <a-upload-dragger
    ref="uploadRef"
    v-model:file-list="fileList"
    :class="uploadType === 'square' ? 'upload-auto-default' : 'upload-auto-custom'"
    :list-type="listType"
    :data="ossObj"
    :accept="accept"
    :disabled="disabled"
    :before-upload="beforeUpload"
    :custom-request="customRequest"
    :max-count="maxCount"
    @remove="handleRemove"
    @change="handleChange"
    @preview="handlePreview"
  >
    <div v-if="uploadType === 'square'" class="auto-square">
      <img class="ant-upload-img" src="~@/assets/icons/ic-upload.png">
      <a-button
        v-if="isDown"
        class="down-btn"
        type="primary"
        :loading="loading"
        @click="downTemplate"
      >{{ loading ? $t('common_text_023') : $t('pages_pay_055') }}</a-button>
      <p class="ant-upload-text">
        <span>{{ $t('common_text_027') }}</span>
        <span>{{ $t('common_text_028') }}</span>
        <span>{{ $t('common_text_029') }}</span>
      </p>
      <p class="ant-upload-hint">
        {{ explain }} {{ $t('common_text_009') }}{{ accept }}
        <span v-if="notes" class="ant-upload-notes">{{ notes }}</span>
      </p>
    </div>
    <div v-else class="auto-round">
      <div class="area">
        <div class="area-content">
          <span v-if="explain">{{ explain }}</span>
        </div>
        <div class="area-btn">{{ $t('common_text_004') }}</div>
      </div>
    </div>
  </a-upload-dragger>
</template>
<script>
import { reactive, toRefs, createVNode } from 'vue'
import { _oss } from '@/api/index'
import { notification, Modal, message } from 'ant-design-vue'
import { generateUUID, fileIsImage } from '@/util'
import i18n from '@/locale/index'
import { number } from 'echarts'
import imageCompression from 'browser-image-compression'
export default {
  name: 'UploadAuto',
  props: {
    accept: {
      type: String,
      default() {
        return ''
      }
    },
    explain: {
      type: String,
      default() {
        return ''
      }
    },
    fileContent: {
      type: String,
      default() {
        return ''
      }
    },
    notes: {
      type: String,
      default() {
        return ''
      }
    },
    maxCount: {
      type: Number,
      default() {
        return 3
      }
    },
    listType: {
      type: String,
      default() {
        return 'text'
      }
    },
    uploadType: {
      type: String,
      default() {
        return 'square'
      }
    },
    isDown: {
      type: Boolean,
      default() {
        return false
      }
    },
    backType: {
      type: String,
      default() {
        return 'string'
      }
    },
    type: {
      type: String,
      default() {
        return 'UPLOAD'
      }
    },
    disabled: {
      type: Boolean,
      default() {
        return false
      }
    },
    nameIndex: {
      type: String,
      default () {
        return ''
      }
    },
    token: {
      type: String,
      default () {
        return ''
      }
    },
    isLt2size: {
      type: number,
      default () {
        return 0
      }
    }
  },
  emits: ['update:fileData'],
  setup(props, ctx) {
    const state = reactive({
      loading: false,
      ossObj: {},
      uploadUrl: '',
      fileData: [],
      fileList: []
    })
    const downTemplate = (e) => {
      e.stopPropagation()
      state.loading = true
      ctx.emit('down', () => {
        state.loading = false
      })
    }
    const fileListRefresh = async (file) => {
      const fileData = []
      const fileList = []
      if (file) {
        const res = await _oss.getOssFileUrl(file)
        if (res.data.succ) {
          const { data } = res.data
          for (const i in data) {
            const uuid = generateUUID()
            fileData.push({ uid: uuid, name: i, path: i })
            fileList.push({ uid: uuid, name: i, thumbUrl: data[i], response: data[i], status: 'done' })
          }
          state.fileData = fileData
          state.fileList = fileList
        }
      }
    }
    const beforeUpload = async (file, fileList) => {
      const fileArea = file.name.split('.')
      if (fileArea[0] && fileArea[0].length > 100) {
        notification.error({
          message: i18n.global.t('common_text_015'),
          description: i18n.global.t('common_text_016')
        })
        if (props.maxCount === 1) ctx.emit('update:fileContent', props.backType === 'array' ? [] : '')
        return false
      }
      if (state.fileList.length > props.maxCount - 1 && props.maxCount !== 1) {
        notification.error({
          message: i18n.global.t('common_text_015'),
          description: i18n.global.t('common_text_011') + props.maxCount + i18n.global.t('common_text_012')
        })
        return false
      }
      if (fileArea[1] && props.accept.indexOf(fileArea[fileArea.length - 1].toLowerCase()) === -1) {
        notification.error({
          message: i18n.global.t('common_text_015'),
          description: i18n.global.t('common_text_009') + props.accept
        })
        if (props.maxCount === 1) ctx.emit('update:fileContent', props.backType === 'array' ? [] : '')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < props.isLt2size
      if (!isLt2M && props.isLt2size) {
        message.error(i18n.global.t('pages_merchant_176'))
        return false
      }
      if (file.type.startsWith('image/') && props.isLt2size) {
        console.log(props.isLt2size, 'props.isLt2size++')
        try {
          // 压缩图片
          const options = {
            maxSizeMB: 0.9, // 最大文件大小（MB）
            maxWidthOrHeight: 1024, // 最大宽度或高度
            useWebWorker: true // 使用 Web Worker 加速压缩
          }
          const compressedFile = await imageCompression(file, options)
          // 返回压缩后的文件
          return compressedFile
        } catch (error) {
          this.$message.error('文件压缩失败')
          console.error('压缩失败:', error)
          return false // 阻止上传
        }
      }
    }
    // 上传文件方法
    const customRequest = async(options) => {
      const { file, data, onSuccess, onError } = options
      const isLt2M = file.size / 1024 / 1024 < props.isLt2size
      if (!isLt2M && props.isLt2size) {
        return
      }
      const formData = new FormData()
      formData.append('file', file)
      formData.append('mb', props.isLt2size ? 1 : 20)
      data.file = file
      await _oss.getUploadFile(formData).then(res => {
        if (res.status === 200) {
          const { data } = res.data
          state.ossObj = {
            key: data
          }
          const params = { filePath: data }
          return _oss.querySsoTempUrl(params)
        } else {
          throw new Error(i18n.global.t('common_text_017'))
        }
      }).then(res => {
        if (res.data.succ) {
          if (props.maxCount === 1) state.fileData = [{ path: state.ossObj.key, uid: state.fileList[state.fileList.length - 1].uid }]
          else state.fileData.push({ path: state.ossObj.key, uid: state.fileList[state.fileList.length - 1].uid })
          const backFiles = state.fileData.map(item => item.path).join(',')
          if (props.backType === 'array') ctx.emit('update:fileContent', state.fileData.map(item => item.path))
          else ctx.emit('update:fileContent', backFiles)
          state.thumbUrl = res.data.data
          onSuccess(res.data.data)
        } else onError()
      }).catch(onError)
    }
    const handlePreview = (file) => {
      const isImg = fileIsImage(file.name)
      if (isImg) {
        Modal.info({
          title: i18n.global.t('pages_receive_047'),
          icon: null,
          width: '35%',
          content: createVNode('img', {
            src: file.response,
            style: { marginTop: '12px', width: '100%' }
          })
        })
      } else {
        window.open(file.response)
      }
    }
    const handleRemove = (file) => {
      state.fileData = state.fileData.filter(item => item.uid !== file.uid)
      const backFiles = state.fileData.map(item => item.path).join(',')
      if (props.backType === 'array') ctx.emit('update:fileContent', state.fileData.map(item => item.path))
      else ctx.emit('update:fileContent', backFiles)
    }
    const handleChange = (info) => {
      if (info.file && info.file.status === 'done') {
        state.fileList = info.fileList.filter(file => file.response)
      } else {
        state.fileList = info.fileList.filter(file => file.status)
      }
      state.fileList = state.fileList.map(item => {
        return Object.assign({}, item, {
          name: item.name.replace(/[%,，]/g, '')
        })
      })
    }
    return {
      downTemplate,
      handleChange,
      beforeUpload,
      customRequest,
      handlePreview,
      handleRemove,
      fileListRefresh,
      ...toRefs(state)
    }
  }
}
</script>

<style lang="less">
.upload-auto-default {
  border-radius: 5px !important;
  border: 2px dashed @main-color !important;
  .ant-upload-drag {
    border-radius: 5px;
    border: 1px dashed @main-color;
    border-width: 3px;
  }
  .auto-square {
    .ant-upload-img {
      width: 50px;
      margin-bottom: 12px;
    }
    .ant-upload-text {
      font-size: 14px !important;
    }
    .ant-upload-text span:nth-child(3) {
      color: @main-color;
    }
    .ant-upload-text span:nth-child(2) {
      margin: 0 5px;
    }
    .ant-upload-notes {
      font-size: 12px;
      color: @error-color;
      margin-left: 5px;
    }
    .ant-upload-hint {
      font-size: 12px !important;
      padding: 0 24px;
      margin-top: 12px;
      text-align: left;
    }
    .down-btn {
      position: absolute;
      right: 24px;
      top: 10px;
    }
  }
}
.upload-auto-custom {
  border: 0 !important;
  background: none !important;
  margin: -12px 0;
  .auto-round {
    .area {
      display: flex;
      border: 1px solid #d9d9d9;
      border-radius: 28px;
      line-height: 32px;
      .area-content {
        width: 75%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #bfbfbf;
        padding: 0 11px;
      }
      .area-btn {
        width: 25%;
        background: @table-th-color;
        border-radius: 28px;
      }
    }
  }
}
.ant-form-item-has-error {
  .upload-auto-default {
    border: 2px dashed @error-color !important;
  }
}
</style>

